import { FormGroup, Text } from '@ksyos/design-system';
import { useMemo } from 'react';
import type { ValidationErrors } from '../../../../utils/validation';
import type { OrthOExaminationOrder } from './orthOExaminationOrder';
import { StyledBorderAndPadding } from '../../../elements/common';
import { InputText } from '../../../userDataManagement/InputText';

interface IOrthOV1ProcedureOdOsOdsFindingsRowProps {
    errors?: ValidationErrors;
    field: string;
    hasErrors?: boolean;
    isReadOnly: boolean;
    isRequired?: boolean;
    label: string;
    tabIndexOd: OrthOExaminationOrder;
    tabIndexOds: OrthOExaminationOrder;
    tabIndexOs: OrthOExaminationOrder;
    value_od?: string | null;
    value_ods?: string | null;
    value_os?: string | null;
}

export function OrthOV1ProcedureOdOsOdsFindingsRow(props: IOrthOV1ProcedureOdOsOdsFindingsRowProps) {
    const { errors, field, hasErrors, isReadOnly, isRequired, label, value_od, value_os, value_ods } = props;

    const showRow = useMemo(
        () => !props.isReadOnly || props.value_od || props.value_os || props.value_ods,
        [isReadOnly]
    );

    return (
        <>
            {showRow && (
                <FormGroup
                    hasErrors={hasErrors}
                    isRequired={!isReadOnly && isRequired}
                    label={label}
                >
                    <div className="row">
                        <div
                            className="col-sm-8"
                            style={{ minWidth: 240 }}
                        >
                            <StyledBorderAndPadding>
                                <Text
                                    fontWeight="bold"
                                    size="xs"
                                >
                                    OD
                                </Text>
                                <ReadOrEditInputField
                                    error={isReadOnly ? '' : errors?.get(`customControlData.${field}_od`)}
                                    fieldKey={`${field}_od`}
                                    isReadOnly={isReadOnly}
                                    placeholder={'Bevindingen...'}
                                    value={isReadOnly ? value_od : undefined}
                                />
                            </StyledBorderAndPadding>
                        </div>
                        <div
                            className="col-sm-8"
                            style={{ minWidth: 240 }}
                        >
                            <StyledBorderAndPadding>
                                <Text
                                    fontWeight="bold"
                                    size="xs"
                                >
                                    OS
                                </Text>
                                <ReadOrEditInputField
                                    error={props.isReadOnly ? '' : errors?.get(`customControlData.${field}_os`)}
                                    fieldKey={`${field}_os`}
                                    isReadOnly={isReadOnly}
                                    placeholder={'Bevindingen...'}
                                    value={isReadOnly ? value_os : undefined}
                                />
                            </StyledBorderAndPadding>
                        </div>
                        <div
                            className="col-sm-8"
                            style={{ minWidth: 240 }}
                        >
                            <StyledBorderAndPadding>
                                <Text
                                    fontWeight="bold"
                                    size="xs"
                                >
                                    ODS
                                </Text>
                                <ReadOrEditInputField
                                    error={isReadOnly ? undefined : errors?.get(`customControlData.${field}_ods`)}
                                    fieldKey={`${field}_ods`}
                                    isReadOnly={isReadOnly}
                                    placeholder={'Bevindingen...'}
                                    value={isReadOnly ? value_ods : undefined}
                                />
                            </StyledBorderAndPadding>
                        </div>
                    </div>
                </FormGroup>
            )}
        </>
    );
}

function ReadOrEditInputField(props: {
    error?: string;
    fieldKey: string;
    isReadOnly: boolean;
    placeholder: string;
    value?: string | null;
}) {
    if (!props.isReadOnly) {
        return <InputText {...props} />;
    } else {
        return <>{props.value ?? ''}</>;
    }
}
